import React from "react";
import { Box } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import IMessage from "../../../../interface/IMessage";
import { AppContext } from "../../../../store/genesys.context";
import IChatbot from "../../../../interface/iChatbot";
import MessageListWrapper from "../../../atoms/wrapper/messageListWrapper.styled";
import RenderBotIsTyping from "../renderBotIsTyping/renderBotIsTyping";
import RenderMessageBox from "../renderMessageBox/renderMessageBox";

const MessageList = (): React.JSX.Element => {
  const {
    chatbot,
    botIsTyping,
  }: {
    chatbot: IChatbot;
    botIsTyping: boolean;
  } = React.useContext(AppContext);

  // scroll to the bottom of the chat when a new message is added
  const chatRef = React.useRef<HTMLDivElement>(null);

  const latestMessage = chatbot.messages.at(-1);
  const latestMessageAnnouncement = latestMessage
    ? `${
        latestMessage.sender === "user"
          ? "Du"
          : latestMessage.sender === "agent"
            ? latestMessage.agent.name?.trim() || "Beratung"
            : latestMessage.sender === "bot"
              ? "Mia"
              : "System"
      }: ${latestMessage.text || (latestMessage.content ? "Anhang empfangen" : "")}`
    : "";

  React.useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [chatbot, botIsTyping]);

  return (
    <MessageListWrapper
      ref={chatRef}
      role="log" // A11Y FIX
      tabIndex={0} // A11Y FIX: macht den scrollbaren Verlauf per Tastatur fokussier- und scrollbar
      aria-live="polite" // A11Y FIX
      aria-relevant="additions text" // A11Y FIX
      aria-atomic={false} // A11Y FIX
      aria-label="Chatverlauf" // A11Y FIX
      aria-busy={botIsTyping} // A11Y FIX
      id="chat-message-log" // A11Y FIX
    >
      <Box component="span" sx={visuallyHidden} aria-live="polite">{/* A11Y FIX */}
        {botIsTyping
          ? "Neue Statusmeldung: Die Beratung schreibt gerade."
          : latestMessageAnnouncement}
      </Box>
      {chatbot.messages.map((message: IMessage, index: number) => (
        <Box
          key={message.id || `${message.sender}-${index}`}
          role="article" // A11Y FIX
          aria-roledescription="Chatnachricht" // A11Y FIX
        >
          <RenderMessageBox message={message} />
        </Box>
      ))}

      {botIsTyping && <RenderBotIsTyping />}
    </MessageListWrapper>
  );
};

export default MessageList;
